import { url, token } from '@/api/api.js'

var myHeaders = new Headers();
myHeaders.append("Cookie", "mailchimp_landing_site=https%3A%2F%2Fccm.sitepreview.app%2Fwc-auth%2Fv1%2Fauthorize%3Fck_4300411a88c76eace32567945afbe0ea92aeb372%3Dcs_50a10ddbd8d0ca76b6435e53273bf9408645d28d");
myHeaders.append("Authorization", "Bearer " + token);
myHeaders.append('Content-Type', 'application/json');

var requestOptions = {
  credentials: 'include',
  method: 'POST',
  headers: myHeaders,
  redirect: 'follow'
};

export default {
  state: {
    errorLogin: '',
    errorNewAccount: '',
    errorForgot: '',
    successForgot: '',
    restorePassError: ''
  },
  mutations: {
    setUserLogin ( state, payload) {            
        state.errorLogin = payload || 0;
    },
    setErrorNewAccount( state, payload) {            
        state.errorNewAccount = payload || 0;
    },
    setErrorForgot ( state, payload) {            
       state.errorForgot = payload || '';
    },
    setSuccessForgot ( state, payload) {            
       state.successForgot = payload || '';
    },
    setRestorePassError ( state, payload) {            
       state.restorePassError = payload || '';
    },   
  },
  actions: {
    async sendUserData({commit}, {login, password, remember}) {      
      commit( 'viewLoader', true );
      requestOptions.body = JSON.stringify({ "form": "login", "login": login, "password": password, "remember": remember });

      try {

        const Data = await fetch(url + "/wp-json/ccm-settings/v1/user-authorization", requestOptions);
        
        const data = await Data.text();
        const dataParse = await JSON.parse(data);
        commit( 'viewLoader', false );

        if(dataParse.error) {

          commit('setUserLogin', dataParse.error);
          throw dataParse.error;

        } else if(dataParse.code == 'invalid_email' || dataParse.code == 'incorrect_password') {

          commit('setUserLogin', 'Unknown email address or wrong phone or password');
          throw dataParse;

        } else if( dataParse.code == 'jwt_auth_invalid_token') {

          commit('setUserLogin', 'Something went wrong, please try again.');
          throw dataParse;

        } else if ( dataParse.code == 'invalid_username') {
          
          commit('setUserLogin', 'Unknown email address or wrong phone.');
          throw dataParse;

        } else if( dataParse.ID ) {
            window.location.href = '/account/';
        } else {
            commit('setUserLogin', 'Something went wrong, please try again.');
            throw dataParse;
        }
        

      } catch ( error ) {
        commit( 'viewLoader', false );
          commit( 'setUserLogin', error.message.replace('username', 'phone') );
          console.log('error', error.message);
          throw error;
          
      }
    },
    async createUserAccount({commit}, data ) {
      commit( 'viewLoader', true );
      requestOptions.body = JSON.stringify( data );

      try {
        const Data = await fetch(url + "/wp-json/ccm-settings/v1/user-create-account", requestOptions);
        const data = await Data.text();
        const dataParse = await JSON.parse(data);
        commit( 'viewLoader', false );
        if( dataParse.error ) {          
          throw dataParse.error;
        } else if(dataParse.code == 'existing_user_login' || dataParse.code == 'existing_user_email') {
          throw dataParse;
        } else if( dataParse.code == 'jwt_auth_invalid_token') {
          dataParse.message= 'Something went wrong, please try again later.';
          throw dataParse;
        } else {
          window.location.href = "/account/";
        }      
      } catch ( error ) {
        commit( 'viewLoader', false );
        commit('setErrorNewAccount', error.message);
        console.log('error', error.message);
        throw error;
          
      }
    },
    async sendForgot({commit}, {email}) {     
      commit( 'viewLoader', true );
      requestOptions.body = JSON.stringify({ "email": email });

      try {

        const Data = await fetch(url + "/wp-json/ccm-settings/v1/send-forgot", requestOptions);
        
        const data = await Data.text();
        const dataParse = await JSON.parse(data);
        commit( 'viewLoader', false );
        if( dataParse.error ) {
          commit('setErrorForgot', dataParse.error);
        } 

        if( dataParse.success ) {
            commit('setSuccessForgot', dataParse.success);
        }


      } catch ( error ) {
        commit( 'viewLoader', false );
        commit( 'setAlertData', {title: 'Error', text: error.message.replace('username', 'phone'), type: 'error', visible: true } );
        console.log('error', error.message);
        throw error;
          
      }
    },
    async restorePassword({commit}, {email, password}) {     
      commit( 'viewLoader', true );
      requestOptions.body = JSON.stringify({ "email": email, "password": password });

      try {

        const Data = await fetch(url + "/wp-json/ccm-settings/v1/restore-pass", requestOptions);
        
        const data = await Data.text();
        const dataParse = await JSON.parse(data);
        
        commit( 'viewLoader', false );
        if( dataParse ) {
          
          let url = window.location.protocol + '//' + window.location.host + '/login/?action=fl&form=login';
          location.href = url;

        } else {

          let error = [];
          error.message = 'An error has occurred. Please try again';            
          commit( 'viewLoader', false );
          commit( 'setAlertData', {title: 'Error', text: error.message, type: 'error', visible: true } );
          throw error;           
        }

      } catch ( error ) {
        commit( 'viewLoader', false );
        commit( 'setRestorePassError', error.message );
        console.log('error', error.message);
        throw error;
          
      }
    },
  },
  getters: {
    errorLogin ( state ) {
      return state.errorLogin;
    },
    errorForgot ( state ) {
      return state.errorForgot;
    },
    errorNewAccount ( state ) {
      return state.errorNewAccount;
    },
    successForgot ( state ) {
      return state.successForgot;
    },
    restorePassError ( state ) {
      return state.restorePassError;
    },
  }
}
